import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { useEffect, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'
import { Loader } from 'core-components/library/loader'
import { Controller, isEmpty, ValidateInput } from 'core-components/library/validation'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { Title } from '../../styledComponents/title/Title'
import { getVersionsCount } from '../helpers/getVersionsCount'

import styles from './CloneVersionContent.module.scss'

interface IProps {
  selectedVersion: IELTData
  saveHandler: (selectedVersion: IELTData, versionName: string, versionSerialNumber: number) => void
}

export const CloneVersionContent = ({ selectedVersion, saveHandler }: IProps) => {
  const { GroupId, PartnerId } = selectedVersion
  const [versionSerialNumber, setVersionSerialNumber] = useState<number>(1)
  const [versionName, setVersionName] = useState('')
  const [wip, setWip] = useState(false)

  const save = () => {
    saveHandler(selectedVersion, versionName, versionSerialNumber)
  }

  useEffect(() => {
    setWip(true)
    getVersionsCount({ groupId: GroupId, partnerId: PartnerId }).then((count) => {
      setVersionSerialNumber(count + 1)
      setVersionName(`Version ${count + 1}`)
      setWip(false)
    })
  }, [GroupId, PartnerId])

  if (wip) {
    return <Loader />
  }

  return (
    <Controller>
      <Title align={'center'} text={getFormedEltTranslation('clone-version')} />
      <ValidateInput checkFn={isEmpty} value={versionName} onChange={setVersionName} />
      <div className={styles.btnWrapper}>
        <Button onClick={save} disabled={!versionName}>
          <Translation text={getFormedEltTranslation('save')} />
        </Button>
      </div>
    </Controller>
  )
}
